import PubSub from "underpub-js";
import Slick from "slick-carousel";
import Equalizer from "../../../../scripts/classes/Equalizer";

var ListingThreeUpImageCardSlider = function(options) {

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

ListingThreeUpImageCardSlider.prototype.init = function() {

	var self = this;

	// sliders
	this.$cardSlider = this.options.$el.find('.card-slider');

	// initialize card slider
	this.$cardSlider.slick({
		arrows: false,
		fade: false,
		speed: 750,
		swipeToSlide: true,
		infinite: false,
		variableWidth: true,

		responsive: [
		
			{
				breakpoint: 768,
				settings: {
					centerMode: true,
					centerPadding: '0px',
					variableWidth: false,
					slidesToShow: 1,
				}
			},

		],

	});

	// previous/next buttons
	this.options.$el.find('.slider-navigation .previous-button').on('click', function() {
		self.$cardSlider.slick('slickPrev');
	});

	this.options.$el.find('.slider-navigation .next-button').on('click', function() {
		self.$cardSlider.slick('slickNext');
	});

	this.$cardSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
	
		self.updateSlideCounter(nextSlide + 1);

	});

	// set up equalizer to set height of slide counter container because children are position: absolute
	this.slideCounterEq = new Equalizer( self.options.$el.find('.slide-counter, .slide-counter .slide-number') );

	this.slideCounterEq.equalizeHeights();

	PubSub.subscribe("resized", function(){
		self.slideCounterEq.equalizeHeights();
	});

};

ListingThreeUpImageCardSlider.prototype.updateSlideCounter = function(slideNumber){

	var self = this;

	this.options.$el.find('.slide-number').removeClass('active');

	this.options.$el.find('.slide-number[data-slide-number="' + slideNumber + '"]').addClass('active');

};

// Math.max.apply(Math, $('.image').map(function(){ return $(this).width(); }).get());

export default ListingThreeUpImageCardSlider;
